import React from 'react';
import Carousel from './Carousel';
import ElephantWordmark from '../../Assets/pipl-elephant-white.svg';
import PiplWordmark from '../../Assets/pipl-wordmark.svg';
import styles from './AuthLayout.module.less';

const currentYear = new Date().getFullYear();

// Decorative scattered squares on the left panel (ported from the design source).
const SQUARES = [
  [68, 34, 1],
  [136, 136, 0.55],
  [170, 170, 0.38],
  [204, 34, 0.4],
  [238, 68, 0.26],
  [102, 238, 0.6],
  [34, 306, 0.35],
  [238, 204, 0.3],
  [204, 374, 0.28],
  [306, 442, 0.22],
  [340, 306, 0.4],
  [374, 340, 0.24],
  [408, 102, 0.3],
  [442, 374, 0.25],
  [340, 34, 0.2],
  [476, 170, 0.22],
];

function fromInitialState(key) {
  return (typeof window !== 'undefined' && window.__INITIAL_STATE && window.__INITIAL_STATE[key]) || null;
}

// Shared shell for every open (logged-out) page: the branded gradient panel +
// marketing carousel on the left is identical across all of them; page content
// on the right. Slides + trust link are server-seeded (see context_processors /
// react_config.html). Search-only; Trust lives in the trust-console repo.
const AuthLayout = ({ children, slides = [], wide = false }) => {
  const trustUrl = fromInitialState('trust_login_url') || '';
  const slidesToShow = fromInitialState('carousel_slides') || slides;

  return (
    <div className={styles.wrap}>
      <aside className={styles.left}>
        <div className={styles.grid} />
        <div className={`${styles.glow} ${styles.glowTop}`} />
        <div className={`${styles.glow} ${styles.glowBottom}`} />
        <div className={styles.squares}>
          {SQUARES.map(([top, left, opacity], i) => (
            <span key={i} className={styles.square} style={{ top, left, opacity }} />
          ))}
        </div>

        <div className={styles.leftInner}>
          <img className={styles.wordmark} src={ElephantWordmark} alt="Pipl — Powered by Elephant" />
          <Carousel slides={slidesToShow} />
        </div>

        <div className={styles.copyright}>© {currentYear} Pipl, Inc. · All rights reserved</div>
      </aside>

      <main className={styles.right}>
        <div className={`${styles.rightInner} ${wide ? styles.rightInnerWide : ''}`}>
          <div className={styles.lockupWrap}>
            <div className={styles.lockupRow}>
              <img className={styles.lockupMark} src={PiplWordmark} alt="pipl" />
              <span className={styles.lockupDivider} />
              <span className={styles.lockupWord}>SEARCH</span>
            </div>
            <span className={styles.accentBar} />
          </div>

          {children}

          <footer className={styles.footer}>
            <a href="https://pipl.com/privacy/" target="_blank" rel="noopener noreferrer">
              Privacy
            </a>
            <a href="https://pipl.com/product-tos/" target="_blank" rel="noopener noreferrer">
              Terms
            </a>
            <a href="https://pipl.com/customer-support" target="_blank" rel="noopener noreferrer">
              Support
            </a>
            {trustUrl && (
              <a className={styles.trustLink} href={trustUrl}>
                Looking for Pipl Trust?
              </a>
            )}
          </footer>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
